import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer style={{ background: '#080808', borderTop: '1px solid rgba(46,204,113,0.08)', padding: '56px 80px 32px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 48 }}>
        {/* Brand */}
        <div>
          <div style={{ marginBottom: 14 }}>
            <span style={{ fontSize: 28, fontWeight: 900, color: '#2ECC71', letterSpacing: -1 }}>MARK</span>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#666', marginLeft: 8 }}>Ms Discoveries</span>
          </div>
          <p style={{ fontSize: 13, color: '#555', lineHeight: 1.9, maxWidth: 280 }}>
            Professional email marketing and warmup solutions. Helping businesses reach the inbox, not the spam folder.
          </p>
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
            {['📧', '📞', '🌐'].map((icon, i) => (
              <div key={i} style={{ width: 36, height: 36, borderRadius: 8, background: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, cursor: 'pointer' }}>{icon}</div>
            ))}
          </div>
        </div>

        {/* Platform */}
        <div>
          <h4 style={{ fontSize: 12, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Platform</h4>
          {[['Features', '/'],['Plans & Pricing', '/plans'],['Email Warmup', '/'],['Email Verifier', '/'],['A/B Testing', '/']].map(([l, h]) => (
            <div key={l} style={{ marginBottom: 10 }}>
              <Link to={h} style={{ fontSize: 13, color: '#555', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#2ECC71'}
                onMouseLeave={e => e.currentTarget.style.color = '#555'}>{l}</Link>
            </div>
          ))}
        </div>

        {/* Company */}
        <div>
          <h4 style={{ fontSize: 12, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Company</h4>
          {[['About Us', '/about'],['Contact', '/contact'],['Privacy Policy', '/privacy'],['Terms & Conditions', '/terms']].map(([l, h]) => (
            <div key={l} style={{ marginBottom: 10 }}>
              <Link to={h} style={{ fontSize: 13, color: '#555', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#2ECC71'}
                onMouseLeave={e => e.currentTarget.style.color = '#555'}>{l}</Link>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h4 style={{ fontSize: 12, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Contact</h4>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: '#444', marginBottom: 4 }}>Email</div>
            <a href="mailto:support@msdiscoveries.com" style={{ fontSize: 13, color: '#888', textDecoration: 'none' }}>support@msdiscoveries.com</a>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: '#444', marginBottom: 4 }}>Phone</div>
            <a href="tel:+919443724724" style={{ fontSize: 13, color: '#888', textDecoration: 'none' }}>+91 9443724724</a>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#444', marginBottom: 4 }}>Working Hours</div>
            <div style={{ fontSize: 12, color: '#555', lineHeight: 1.6 }}>Mon – Sat<br />10:00 AM – 6:00 PM</div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.04)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div style={{ fontSize: 12, color: '#333' }}>
          © {new Date().getFullYear()} <span style={{ color: '#2ECC71', fontWeight: 700 }}>MARK</span> by MS Discoveries. All rights reserved.
        </div>
        <div style={{ display: 'flex', gap: 20 }}>
          {[['Privacy', '/privacy'],['Terms', '/terms'],['Contact', '/contact']].map(([l, h]) => (
            <Link key={l} to={h} style={{ fontSize: 12, color: '#444', textDecoration: 'none' }}>{l}</Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
